import { LayoutPart, Pin, TeacherPin } from '../../models';

export type LayoutPartDict = Partial<Record<LayoutPart, string>>;
/**
 * Dumb down the type to make it easier to work with
 * If you know the exact type, you will only have the layoutParts available for that type
 */
export type PinWithLayoutParts<T extends Pin = TeacherPin> = T & {
  settings: { layoutParts: LayoutPartDict };
};

export function isPinWithLayoutParts<T extends Pin>(pin: T): pin is PinWithLayoutParts<T> {
  return 'layoutParts' in pin.settings;
}

export function getLayoutParts(pin: Pin): LayoutPartDict {
  if (isPinWithLayoutParts(pin)) {
    return pin.settings.layoutParts;
  }
  return {};
}
